import React, {useState} from "react";
import {Card, CardBody, Col, Form, FormGroup, Input, Label, Row} from 'reactstrap';
import {
    ButtonCancel,
    ButtonSubmit,
} from "../../../components/buttons/buttonsActions";
import { useForm } from "react-hook-form";
import {setForm, setItem} from "../../../redux/actions/generalActions/formActions";
import {save, update} from "../../../redux/actions/eventx/busScheduleActions";
import {connect} from "react-redux";
import SelectGeneric from "../../../components/select/selectGeneric";
import {busPickupProvider} from "../../../providers/eventx/busPickupProvider";
import {busDateProvider} from "../../../providers/eventx/busDateProvider";
import {busRouteProvider} from "../../../providers/eventx/busRouteProvider";

const BusScheduleForm = props => {
    const { editMode, domainObject } = props.formProps;
    const fbDataBaseId = props.mainProps?.app?.fbDataBase?.id
    const [busDate, setBusDate] = useState(domainObject?.busDate?.id || null);
    const [busPickup, setBusPickup] = useState(domainObject?.busPickup?.id || null);
    const [busRoute, setBusRoute] = useState(domainObject?.busRoute?.id || null);

    const {register, handleSubmit, reset} = useForm({
        defaultValues: {
            departure: domainObject?.departure,
        }
    });

    const onSubmit = (data, _) => {
        const dataRequest = {
            noDb : false,
            allDb : false,
            fbDataBase :  { id : fbDataBaseId },
            item : {
                id: domainObject?.id,
                uid: domainObject?.uid,
                departure: data.departure,
                busDate,
                busPickup,
                busRoute
            }
        };

        try{
            if (editMode) {
                let id = domainObject.id;

                props.update(id, dataRequest)
            } else {
                props.save(dataRequest)
            }
            closeForm()
        } catch (error) {
            console.log(error)
        }
    };

    const closeForm = () => {
        reset();
        props.setItem(null);
        props.setForm();
        props.onClose()
    }

    return <>
        <Card style={{minWidth: '570px'}}>
            <CardBody>
                <Form onSubmit={handleSubmit(onSubmit)}>
                    <Row>
                        <Col md="6">
                            <FormGroup>
                                <Label>Salida</Label>
                                <Input type="text" name="departure"
                                       placeholder="Ingrese el lugar de salida"
                                       innerRef={register}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="6">
                            <FormGroup>
                                <Label>Pickup - Drop off</Label>
                                <br/>
                                <SelectGeneric
                                    initialValue={busPickup}
                                    setExternalValue={setBusPickup}
                                    provider={busPickupProvider}
                                    fbDataBaseId={fbDataBaseId}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md="6">
                            <FormGroup>
                                <Label>Ruta</Label>
                                <br/>
                                <SelectGeneric
                                    initialValue={busRoute}
                                    setExternalValue={setBusRoute}
                                    provider={busRouteProvider}
                                    fbDataBaseId={fbDataBaseId}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="6">
                            <FormGroup>
                                <Label>Fecha</Label>
                                <br/>
                                <SelectGeneric
                                    initialValue={busDate}
                                    setExternalValue={setBusDate}
                                    provider={busDateProvider}
                                    fbDataBaseId={fbDataBaseId}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <CardBody className="border-top">
                        <div className="float-right">
                            <ButtonSubmit/>
                            <ButtonCancel onClick={closeForm}/>
                        </div>
                    </CardBody>
                </Form>
            </CardBody>
        </Card>
    </>

}

const mapStateToProps = state => ({
    mainProps: state.mainProps,
    formProps: state.formProps,
})

const mapActionsToProps = ({
    setItem,
    setForm,
    save,
    update,
})

export default connect(mapStateToProps, mapActionsToProps)(BusScheduleForm)
